
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-story-our-people",
      function () {
        return require("private-next-pages/our-story-our-people/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-story-our-people"])
      });
    }
  